var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-img',{staticStyle:{"position":"absolute","bottom":"0"},attrs:{"src":_vm.getImage,"contain":"","width":"100%"}})}
var staticRenderFns = []

export { render, staticRenderFns }